export default __webpack_public_path__ + "static/media/illus-datasets.639bdfc5.svg";